import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/69fb7769f6558f0014ee04ec_1780685555534_0807b788/jmcadmin/src/app/page.tsx");
